import type { QuestionAssignmentAnswer } from 'domain/question';
import type { PerspectiveApi } from 'store/apis/event/types';

// The room's list holds every topic that ran in it; the store holds one topic's perspectives.
export const mapRoomPerspectivesFromApi = (
  perspectives: PerspectiveApi[],
  topicId: number
): QuestionAssignmentAnswer[] =>
  perspectives
    .filter((perspective) => perspective.topicId === topicId)
    .map(({ perspectiveId, text, authorIds, isAnonymous }) => ({
      type: 'TextAnswer',
      uuid: perspectiveId,
      assignedToUserIds: authorIds,
      text,
      isAnonymous,
    }));
